var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card__new-banner",style:({ color: _vm.color, backgroundColor: _vm.backgroundColor })},[_vm._v("\n    "+_vm._s(_vm.product.banner_text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }